import { render, staticRenderFns } from "./PayrollContributions.vue?vue&type=template&id=71cf9180&scoped=true"
import script from "./PayrollContributions.vue?vue&type=script&lang=ts"
export * from "./PayrollContributions.vue?vue&type=script&lang=ts"
import style0 from "./PayrollContributions.vue?vue&type=style&index=0&id=71cf9180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf9180",
  null
  
)

export default component.exports